document.addEventListener("DOMContentLoaded", () => {
  let sideMenuInitialized = false;
  const observer = new MutationObserver(() => {
    if (document.body.hasAttribute("data-drawer") && !sideMenuInitialized) {
      sideMenuInitialized = true;
      let navTrigger = document.querySelector(".mobile-nav__trigger");
      const mobileMenu = document.querySelector(".er-drawer");

      navTrigger?.replaceWith(navTrigger.cloneNode(true));
      navTrigger = document.querySelector(".mobile-nav__trigger");

      navTrigger?.addEventListener("click", (e) => {
        e.stopPropagation();
        console.log("this is the click that i was expecting");
        mobileMenu?.classList.toggle("active");
      });

      mobileMenu
        ?.querySelector(".er-drawer__close")
        ?.addEventListener("click", () => {
          mobileMenu.classList.remove("active");
        });

      const collapsibles = document.querySelectorAll(".er-drawer__collapsible");
      console.log("collapsible", collapsibles);

      collapsibles.forEach((collapsible) => {
        const showIcon = collapsible.querySelector(".er-drawer--open");
        const closeIcon = collapsible.querySelector(".er-drawer--close");

        collapsible.addEventListener("click", () => {
          const menu = collapsible.parentNode?.querySelector("ul");
          showIcon?.classList.toggle("hidden");
          closeIcon?.classList.toggle("hidden");

          menu?.classList.toggle("active");
        });
      });
    }
  });

  observer.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
  });
});
